"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function autoCapitalize(node, capitalize = true) {
    if (typeof node !== 'string' || node.length === 0 || !capitalize) {
        return node;
    }
    return `${node[0].toUpperCase()}${node.slice(1)}`;
}
exports.default = autoCapitalize;
//# sourceMappingURL=autoCapitalize.js.map